import type {BulkUpdateSummary} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import type {DataValue} from 'schemaDefinition/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';

export const bulkUpdateSummaryTableConfig: TableConfiguration<BulkUpdateSummary> =
  {
    ...defaultTableConfig,
    disableSorting: true,
    partValueGetters: {
      created: (_, value) =>
        (typeof value === 'number' ? new Date(value) : null) as DataValue,
      completed: (_, value) =>
        (typeof value === 'number' ? new Date(value) : null) as DataValue,
    },
  };
